module.exports = __webpack_public_path__ + "static/media/portrait7.2f589e90.jpg";